import { IPokerCard } from '@bg-shared/interfaces/Draws/Poker';
import { IFormattedBettingOptions } from '@bg-shared/interfaces/IBettingOption';
import { POKER_HANDS_COUNT } from '@bg-shared/constants/constants';

export const assignCardsToBettingOptions = (
    cards: IPokerCard[],
    handsBettingOptionsIds: number[],
    bettingOptions: IFormattedBettingOptions,
): void => {
    handsBettingOptionsIds.forEach((id, index) => {
        const firstCard = cards[index + POKER_HANDS_COUNT];
        const secondCard = cards[index];

        bettingOptions[id].cards = firstCard && secondCard ? [firstCard, secondCard] : [];
    });
};
